import React from 'react';
import DetailPage from '../../components/DetailPage';

export default function ManagedIT() {
  return <DetailPage type="service" id="managed-it" />;
}
